'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signUp = exports.signIn = exports.resetPassword = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

var resetPassword = exports.resetPassword = function resetPassword() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.resetPassword)(params) : (0, _everydayhero.resetPassword)(params);
};

var signIn = exports.signIn = function signIn() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.signIn)(params) : (0, _everydayhero.signIn)(params);
};

var signUp = exports.signUp = function signUp() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.signUp)(params) : (0, _everydayhero.signUp)(params);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/authentication/index.js
// module id = 245
// module chunks = 0